const system_limit = {
    limit_exceeded: 'Has alcanzado el límite del sistema. Ponte en contacto con el soporte para obtener ayuda.',
};
export default Object.freeze(system_limit);
